import React from 'react'
import i18n from 'constants/strings'
import WTNSpinner from './WTNSpinner'
import BtnSecondary from './BtnSecondary'

interface LoadMoreProps {
  loading?: boolean
  loadMore?: () => void
  text?: string
}

const LoadMore: React.FC<LoadMoreProps> = ({
  loading,
  loadMore,
  text = i18n.t('searchResults.showMore'),
}: LoadMoreProps) => {
  if (loading) return <WTNSpinner width={45} />

  return (
    <BtnSecondary onClick={loadMore} size='medium' fullWidthAtMobile>
      {text}
    </BtnSecondary>
  )
}

export default LoadMore
